import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'app/core/services/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-send-leaves',
  templateUrl: './dialog-send-leaves.component.html',
  styleUrls: ['./dialog-send-leaves.component.scss']
})
export class DialogSendLeavesComponent implements OnInit {

  isLoading: boolean = false;
  emailGroup: FormGroup;
  department: any[] = [];
  branch: any[] = [];

  constructor(public dialogRef: MatDialogRef<DialogSendLeavesComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private toastr: ToastrService, private commonService: CommonService) {
    this.emailGroup = this.fb.group({
      email: ['', Validators.required]
    });
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submit() {
    this.isLoading = true;
    this.commonService.sendPendingLeaves(this.emailGroup.value.email).subscribe({
      next: res => {
        this.isLoading = false;
        if(res) {
          this.dialogRef.close();
        } else {
          this.isLoading = false;
          this.showNotificationError("Failed to send email. Please try again later.");
        }
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
        this.showNotificationError("Failed to send email. Please try again later.");
      }
    })
  }

  showNotificationError(text) {
    this.toastr.success('<span class="now-ui-icons ui-1_bell-53"></span> ' + text + '', '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: "alert alert-danger alert-with-icon",
      positionClass: 'toast-' + 'top' + '-' + 'center'
    });
  }
}
